 
	import MatriculaService  from '@/service/v10/sigap/MatriculaService'; 
	import $ from "jquery"  
    import CardRh from   "@/components/cards/ManzaCard.vue" 
    import { Options , Vue } from "vue-class-component";   
    import KDataTable from   "@/components/datatable/newdatatable.vue"  
    import { User } from "@/store/modules/AuthModule";
    import { namespace } from 'vuex-class';   
    const authStore = namespace('auth');  

	  
    @Options({
        name: "Curso",
        components: {  CardRh , KDataTable  },   
    }) 
    export default class Curso extends Vue {
        
        
        @authStore.Getter
		public currentUser!: User 
 
        @authStore.Getter
		public token!: any 

        public cpf: any = null; 
        public processando = false; 
        public reloadDatatable = false ;
        public config; 
        public service;   
        public rota = "";
        public dados_historico = null ; 
        public dados_falta = null ; 
        public dados_nota = null ; 
        public modal_historico = 'modal_profile_historico' ;
        public modal_falta = 'modal_profile_falta' ;
        public modal_certificado = 'modal_profile_certificado' ;
        public modal_nota = 'modal_profile_nota' ;

        get hasPermissao(   ): boolean {
            return true;
        }
 
        created(){
            this.config = {  ajax: {} , columns: [] , columnDefs: [] }; 
            this.service = new MatriculaService();  
            this.cpf = this.currentUser.id;

            this.config.ajax = { 
                url: this.service.getApiUrl()  ,
                data: function ( d ) {   
                    const dados = {
                        "Skip": d.start,
                        "Take": d.length, 
                        "search": d.search.value
                    }
                    return dados; 
                } 
            }; 
              
            this.config.columns = [ 
                { data: 'id', name: 'id' }, 
                { data: 'turma.descricao', name: 'turma.descricao' }, 
                { data: 'status.nome', name: 'status.nome' }, 
                { data: 'mediaFinal', name: 'mediaFinal' }, 
                { data: 'id', name: 'id'  , orderable: false, searchable: false , class: 'text-center' }
            ];
            this.config.columnDefs = [ 
                {
                    targets: 2,
                    render: function ( row, type, val, meta ) {  
                        return  row.replaceAll('_' , ' ')  ;  
                    }
                }, 

                {
                    targets: 4,
                    render: ( row, type, val, meta ) => {  
                        let texto = '' ;
                        
                        let buttom =  ' data-matricula_id'+'="'+ val.id +'"'; 
                        buttom = buttom + ' data-turma_descricao'  + '="'+ val.turma.descricao +'"'   
                        texto +=  '<button class="btn btn-pmes-primary btn-sm" btn-show-matricula '+ buttom +' "><i class="fa fa-eye"></i> Visualizar</button>';
 
                        return texto;  
                    }, 
                }
            ]; 
        }
          
        public tableatualizada( event ) {   
            $('[btn-show-matricula]').click(  (btn) => {   
                let id =   $(btn.currentTarget).data('matricula_id');   
                const routeData = this.$router.resolve({name: 'profile_matricula_show',  params: {  id: id  } });
                window.open(routeData.href, '_blank');   
            });  
        }  
    
    } 
